import amd from './amd';
import cjs from './cjs';
import umd from './umd';

export default {
	amd: amd,
	cjs: cjs,
	umd: umd
};
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/standalone/builders/strictMode/index.js.01-babel.map